/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SearchResultsShownParams {
  /** PII ガード済みの入力キーワード（正規化後。送信抑止時は空文字） */
  keyword: string;
  result_count: number;
}

/**
 * 発火タイミング：候補 / 結果が描画され件数が確定した際（1 検索成立につき 1 回）
 */
export const sendGAWabunkaSearchResultsShownEvent = (keyword: string, resultCount: number) => {
  sendWabunkaGAEvent('search_results_shown', { keyword, result_count: resultCount });
};
